import { render, staticRenderFns } from "./ArrivalReport.vue?vue&type=template&id=006683e7&scoped=true&"
import script from "./ArrivalReport.vue?vue&type=script&lang=js&"
export * from "./ArrivalReport.vue?vue&type=script&lang=js&"
import style0 from "./ArrivalReport.vue?vue&type=style&index=0&id=006683e7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006683e7",
  null
  
)

export default component.exports